import React, {useEffect, useState} from 'react'
import { Button, Modal, Upload, Input, Form, message, InputNumber, DatePicker } from "antd";
// react-redux
import { useSelector, useDispatch } from "react-redux";
import { closePestThresholdModal } from 'store/reducers/pestThresholdModal';
import { Notification } from 'components/notification/Notification';
import { useUpdatePestThresholdMutation } from 'api/degreeDaysApi';
import moment from 'moment';
import { Select, Space,Collapse  } from 'antd';
import dayjs from 'dayjs';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import MomentDatePicker from 'components/antd-date-picker/MomentDatePicker';

const { Panel } = Collapse;
const { Option } = Select;

const PestThresholdModal = ({pestThreshold}) => {
  const [form] = Form.useForm();
  const formRef = React.useRef(null);
  const [updatePestThreshold] = useUpdatePestThresholdMutation();
  const { isOpen, componentData } = useSelector(
    (state) => state.pestThresholdModal
  );
  const [pestId, setPestId] = useState();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue({
        lower_temp: componentData ? componentData?.lowerTemperatureThreshold : "",
        upper_temp: componentData ? componentData?.upperTemperatureThreshold : "",
        biofix: componentData ? componentData?.bioFix : null,
        dateTime: componentData.bioFix ? moment(componentData.bioFix, 'YYYY-MM-DD') : null,
      });
      setPestId(componentData?.pestId);
    
   
    }

  }, [componentData]);

  const onFinish = async (values) => {
    console.log('Received values from form:', values);
    // Format and submit this data to your backend as needed.
};
const handleUpdatePestThreshold = () => {
    form
      .validateFields()
      .then((values) => {
        const formData = new FormData();
        formData.append("LowerTemperatureThreshold", values?.lower_temp);
        formData.append("UpperTemperatureThreshold", values?.upper_temp);
        if (values?.dateTime){
          formData.append("Biofix",values?.dateTime.toISOString());
        }
     
        formData.append("pestId", pestId);

       setIsLoading(true);
        updatePestThreshold({
          pestThreshold: formData,
          pestId: pestId
        })
          .then((response) => {
            if (response?.error?.status === 409) {
              Notification(
                "error",
                "Operation failed",
                "Record already exists"
              );
            } else {
          
              form.resetFields();
              handleCancel();
              Notification(
                "success",
                "Operation successful",
                "Pest Threshold updated successfully"
              );
              setIsLoading(false);
            }
          })
          .catch((error) => {
            console.log(error);
            Notification(
              "error",
              "Operation failed",
              "Unable to update Pest Threshold"
            );
            setIsLoading(false);
          });
      })
      .catch((error) => {
        console.log(error);
        Notification(
          "error",
          "Operation failed",
          "Unable to update Pest Threshold"
        );
        setIsLoading(false);
      });
  };

  const handleCancel = () => {
    dispatch(closePestThresholdModal());
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Validation Failed:", errorInfo);
  };
  return (
    <Modal
      open={isOpen}
      title={"Update Pest Threshold"}
      onCancel={handleCancel}
      maskClosable={false}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Return
        </Button>,
        <>
            <Button
              key="submit"
              type="primary"
              onClick={handleUpdatePestThreshold}
              loading = {isLoading}
            >
              {isLoading ? "Updating Data..." : "Change Threshold Values"}
            </Button>
        </>,
      ]}
    >
      <Form
  encType="multipart/form-data"
  form={form}
  layout={"vertical"}
  ref={formRef}
  name="control-ref"
  onFinishFailed={onFinishFailed}
  style={{
    maxWidth: 600,
  }}
>
  <Form.Item
    name="lower_temp"
    label="Base Temperature"
    rules={[
      {
        required: true,
        type: 'number',
        message: 'Please enter a valid number',
      },
    ]}
  >
    <InputNumber
      value={form.getFieldValue("lower_temp")}
      type="number"
      onChange={(value) => form.setFieldsValue({ lower_temp: value })}
      placeholder={"Enter Temperature Threshold..."}
      style={{ width: '100%' }} 
      
    />
  </Form.Item>
  <Form.Item
    name="upper_temp"
    label="Optimal Temperature"
    rules={[
      {
        required: true,
        type: 'number',
        message: 'Please enter a valid number',
      },
    ]}
  >
    <InputNumber
      value={form.getFieldValue("upper_temp")}
      onChange={(value) => form.setFieldsValue({ upper_temp: value })}
      placeholder={"Enter Upper Temperature Threshold..."}
      style={{ width: '100%' }} 
      type="number"
    />
  </Form.Item>
 
  

  <Form.Item
  name="dateTime"
  label="Select BioFix"

>

  <MomentDatePicker
   value={form.getFieldValue("dateTime")}
    placeholder="Select Date and Time"
    format={"YYYY-MM-DDTHH:mm:ss"}
    style={{ width: '100%' }}
    onChange={(value) => form.setFieldsValue({dateTime : value })}
   // showTime 
    form ={form}
  />
</Form.Item>
</Form>
    </Modal>
  )
}

export default PestThresholdModal
